export const getOrderTransactionHistoryUrl = order_id => {
    return `/orders/${order_id}/transactions`;
};
